module.exports = __webpack_public_path__ + "img/p119.da3afc52.jpg";